import React from "react";
import "../styles/Services.css";

// Import Assets
import cutService from "../assets/images/service_cut.jpg";
import Service02 from "../assets/images/service02.jpg";
import Service03 from "../assets/images/service03-2.jpg";
// import Service04 from "../assets/images/service04.jpg";
import Service04 from "../assets/images/service04-2.jpg";

function Services() {
  return (
    <div className="Services">
      <h1>Nuestros Servicios</h1>
      <div className="Main-Container">
        {/* Services Items */}
        <div className="Card-Container">
          <div className="Card__Image">
            <img src={Service02} alt="" />
          </div>

          <div className="Card__Section">
            <div className="Card-Text">
              <h6>Corte</h6>
              <p>Relájate mientras tu barbero logra tu look a la medida.</p>
            </div>
            {/* <div className="Card__button">
              <button>
                <a href="#">Ver más</a>
              </button>
            </div> */}
          </div>
        </div>

        <div className="Card-Container">
          <div className="Card__Image">
            <img src={cutService} alt="" />
          </div>
          <div className="Card__Section">
            <div className="Card-Text">
              <h6>Barba</h6>
              <p>
                Creamos el estilo de barba o bigote que siempre has querido.
              </p>
            </div>
          </div>
        </div>

        <div className="Card-Container">
          <div className="Card__Image">
            <img src={Service03} alt="" />
          </div>
          <div className="Card__Section">
            <div className="Card-Text">
              <h6>Especial</h6>
              <p>Nos encargaremos del estilo que buscas.</p>
            </div>
          </div>
        </div>

        <div className="Card-Container">
          <div className="Card__Image">
            <img src={Service04} alt="" />
          </div>
          <div className="Card__Section">
            <div className="Card-Text">
              <h6>Kids</h6>
              <p>Contamos con estilos especializados en niños.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
